import { IFilter, IFilterOption } from '../../interfaces/Filter.interfaces';
import { filterSliderConstant } from './slider/filterSliderConstant';

export interface IMarketPriceFilterOption extends IFilterOption {
  value: MarketPriceFilterOptionValueType;
  description?: string;
}

export type marketPriceFilterKeyType = 'sorter' | 'filter_brand' | 'engineOutputInPs' | 'medianPrice';

export interface IMarketPriceFilter extends IFilter {
  key: marketPriceFilterKeyType;
  options: IMarketPriceFilterOption[];
}

export enum MarketPriceFilterOptionValueSorterEnum {
  default_desc = 'default_desc',
  medianPrice_desc = 'medianPrice_desc',
  engineOutputInPs_desc = 'engineOutputInPs_desc',
}

type MarketPriceFilterOptionValueType = MarketPriceFilterOptionValueSorterEnum | string | number;

const marketPriceFilterSorterConstant: IMarketPriceFilter = {
  key: 'sorter',
  title: '정렬',
  optionType: 'radio',
  options: [
    {
      optionName: '기본 정렬순',
      value: MarketPriceFilterOptionValueSorterEnum.default_desc,
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '가격순',
      value: MarketPriceFilterOptionValueSorterEnum.medianPrice_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '마력순',
      value: MarketPriceFilterOptionValueSorterEnum.engineOutputInPs_desc,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const marketPriceFilterPriceConstant: IMarketPriceFilter = {
  key: 'medianPrice',
  title: '가격',
  buttonTitle: '가격으로 보기',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: filterSliderConstant.medianPrice.min,
      defaultValue: filterSliderConstant.medianPrice.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: filterSliderConstant.medianPrice.max,
      defaultValue: filterSliderConstant.medianPrice.max,
      isSelected: true,
    },
  ],
};

const marketPriceFilterEngineOutputInPsConstant: IMarketPriceFilter = {
  key: 'engineOutputInPs',
  title: '마력',
  buttonTitle: '마력으로 보기',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: filterSliderConstant.engineOutputInPs.min,
      defaultValue: filterSliderConstant.engineOutputInPs.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: filterSliderConstant.engineOutputInPs.max,
      defaultValue: filterSliderConstant.engineOutputInPs.max,
      isSelected: true,
    },
  ],
};

const marketPriceFilterBrandConstant: IMarketPriceFilter = {
  key: 'filter_brand',
  title: '브랜드',
  buttonTitle: '브랜드로 보기',
  optionType: 'checkbox',
  options: [],
};

export const marketPriceFiltersConstant: IMarketPriceFilter[] = [
  marketPriceFilterBrandConstant,
  marketPriceFilterEngineOutputInPsConstant,
  marketPriceFilterPriceConstant,
  marketPriceFilterSorterConstant,
];
